/**
 * scrapbookPapers — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {A4, tagline, chips, type ToilePack} from './data'

export const scrapbookPapersPack: ToilePack = {
    slug: 'scrapbook-papers',
    category: 'scrapbook',
    name: 'Scrapbook papers',
    tagline: tagline('sheets', 'themes', 'formats'),
    chips: chips('themes', 'formats'),
    ratio: A4,
    readings: [
        {key: 'travel', label: 'Vintage travel', subject: 'old maps, stamps, luggage tags and compasses'},
        {key: 'baby', label: 'Baby milestones', subject: 'rattles, tiny footprints, prams and moons'},
        {key: 'autumn', label: 'Autumn harvest', subject: 'oak leaves, pumpkins, acorns and plaid'},
    ],
    styles: [
        {key: 'collage', label: 'Collage sheet', style: 'cut-out ephemera in a loose grid', palette: 'aged paper edges on white', framing: 'isolated, cuttable pieces'},
        {key: 'paper', label: 'Patterned paper', style: 'full-bleed repeated background paper', palette: 'coordinated theme palette', framing: 'edge to edge, soft paper texture'},
        {key: 'journal', label: 'Journal cards', style: 'six blank cards in a 2×3 grid', palette: 'coordinating patterns and washes', framing: 'thin cut lines, empty writing areas'},
    ],
    directions: ['a seaside holiday instead', 'in muted vintage tones', 'larger motifs, more space'],
}
